export const Theme = {
  colors: {
    primary: '#2D84C6',
    secondary: '#ff7a45',
    ternary: '#244472',
    success: '#73d13d',
    info: '#40a9ff',
    error: '#ff4d4f',
    warning: '#ff7a45',
    white: '#fafafa',
    gray: '#f0f0f0',
    darkGray: '#eaeaea',
    black: '#1f1f1f',
    bg: 'linear-gradient(180deg, #EAEFF3, #FAFBFC)',
  },
  shadows: {
    base: '0 12px 24px rgba(0, 0, 0, 0.1)',
    soft: '0 3px 6px rgba(0, 0, 0, 0.05)',
  },
};
